import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { BookingHighSchoolInfo } from '../booking-high-school-info';
import { InternationalPhoneNumberValidator } from '../validator/international-phone-number-validator';
import { EmailAddressValidator } from '../validator/email-address-validator';
import { ToastMessageService } from '../toast-message.service';
import { SchoolContact } from '../school-contact';
import { SchoolContactType } from '../school-contact-type';
import { School } from '../school';
import { ApiError } from '../api-error';
import { SelectItem } from 'primeng/api';


@Component({
  selector: 'app-edit-booking-high-school',
  templateUrl: './edit-booking-high-school.component.html',
  styleUrls: ['./edit-booking-high-school.component.css']
})
export class EditBookingHighSchoolComponent implements OnInit {

  highSchoolForm: FormGroup;
  selectedSchoolContacts: SchoolContact[] = [];
  schoolContactOptions: SelectItem[] = [];
  schoolContactTypes: SchoolContactType[] = [];

  constructor(
    private builder: FormBuilder,
    private bookingService: BookingService,
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) {
    this.highSchoolForm = this.builder.group({
      schoolName: null,
      schoolPhone: [null, InternationalPhoneNumberValidator],
      schoolAddress: null,
      schoolCity: null,
      schoolPostCode: null,
      schoolWebsiteUrl: null,
      schoolEmail: [null, EmailAddressValidator],
      localCoordinatorName: null,
      localCoordinatorPhone: [null, InternationalPhoneNumberValidator],
      localCoordinatorEmail: [null, EmailAddressValidator],
      schoolCoordinatorName: null,
      schoolCoordinatorPhone: [null, InternationalPhoneNumberValidator],
      schoolCoordinatorEmail: [null, EmailAddressValidator],
      comment: null,
      selectedContact: null,
      contactForms: new FormArray([])
    });
   }

  ngOnInit(): void {
    let booking = this.bookingService.booking;
    if(booking.highSchoolInfo){
      let highSchoolInfo = booking.highSchoolInfo;
        this.highSchoolForm.get("schoolName")!.setValue(highSchoolInfo.schoolName);
        this.highSchoolForm.get("schoolPhone")!.setValue(highSchoolInfo.schoolPhone);
        this.highSchoolForm.get("schoolAddress")!.setValue(highSchoolInfo.schoolAddress);
        this.highSchoolForm.get("schoolCity")!.setValue(highSchoolInfo.schoolCity);
        this.highSchoolForm.get("schoolPostCode")!.setValue(highSchoolInfo.schoolPostCode);
        this.highSchoolForm.get("schoolWebsiteUrl")!.setValue(highSchoolInfo.schoolWebsiteUrl);
        this.highSchoolForm.get("schoolEmail")!.setValue(highSchoolInfo.schoolEmail);
        this.highSchoolForm.get("localCoordinatorName")!.setValue(highSchoolInfo.localCoordinatorName);
        this.highSchoolForm.get("localCoordinatorPhone")!.setValue(highSchoolInfo.localCoordinatorPhone);
        this.highSchoolForm.get("localCoordinatorEmail")!.setValue(highSchoolInfo.localCoordinatorEmail);
        this.highSchoolForm.get("schoolCoordinatorName")!.setValue(highSchoolInfo.schoolCoordinatorName);
        this.highSchoolForm.get("schoolCoordinatorPhone")!.setValue(highSchoolInfo.schoolCoordinatorPhone);
        this.highSchoolForm.get("schoolCoordinatorEmail")!.setValue(highSchoolInfo.schoolCoordinatorEmail);
        this.highSchoolForm.get("comment")!.setValue(highSchoolInfo.comment);
        if(highSchoolInfo.schoolContactList){
          this.selectedSchoolContacts = highSchoolInfo.schoolContactList;
        }
    } 
    this.httpService.getSchoolContacts(booking.school.id!).subscribe(res => {
      for(let contact of res){
        this.schoolContactOptions.push({label: contact.name + ", " + contact.schoolContactType.name, value: contact});
      }
    });
    this.httpService.getSchoolContactTypes().subscribe(res => {
      this.schoolContactTypes = res;
    });
  }

  submit(){
    if(this.highSchoolForm.invalid){
      this.toastService.addError("Error", "Something is wrong in form input");
      return;
    }
    let highSchoolInfo = this.bookingService.booking.highSchoolInfo;
    //Update existing high school info
    if(highSchoolInfo != null){
      highSchoolInfo.schoolName = this.highSchoolForm.value.schoolName;
      highSchoolInfo.schoolPhone = this.highSchoolForm.value.schoolPhone;
      highSchoolInfo.schoolAddress = this.highSchoolForm.value.schoolAddress;
      highSchoolInfo.schoolCity = this.highSchoolForm.value.schoolCity;
      highSchoolInfo.schoolPostCode = this.highSchoolForm.value.schoolPostCode;
      highSchoolInfo.schoolWebsiteUrl = this.highSchoolForm.value.schoolWebsiteUrl;
      highSchoolInfo.schoolEmail = this.highSchoolForm.value.schoolEmail;
      highSchoolInfo.localCoordinatorName = this.highSchoolForm.value.localCoordinatorName;
      highSchoolInfo.localCoordinatorPhone = this.highSchoolForm.value.localCoordinatorPhone;
      highSchoolInfo.localCoordinatorEmail = this.highSchoolForm.value.localCoordinatorEmail;
      highSchoolInfo.schoolCoordinatorName = this.highSchoolForm.value.schoolCoordinatorName;
      highSchoolInfo.schoolCoordinatorPhone = this.highSchoolForm.value.schoolCoordinatorPhone;
      highSchoolInfo.schoolCoordinatorEmail = this.highSchoolForm.value.schoolCoordinatorEmail;
      highSchoolInfo.comment = this.highSchoolForm.value.comment;
      highSchoolInfo.schoolContactList = this.selectedSchoolContacts;
    } else {
      //Creating new high school info
      let info = new BookingHighSchoolInfo(
        this.highSchoolForm.value.schoolName,
        this.highSchoolForm.value.schoolPhone,
        this.highSchoolForm.value.schoolAddress,
        this.highSchoolForm.value.schoolCity,
        this.highSchoolForm.value.schoolPostCode,
        this.highSchoolForm.value.schoolWebsiteUrl,
        this.highSchoolForm.value.schoolEmail,
        this.highSchoolForm.value.localCoordinatorName,
        this.highSchoolForm.value.localCoordinatorPhone,
        this.highSchoolForm.value.localCoordinatorEmail,
        this.highSchoolForm.value.schoolCoordinatorName,
        this.highSchoolForm.value.schoolCoordinatorPhone,
        this.highSchoolForm.value.schoolCoordinatorEmail,
        this.highSchoolForm.value.comment,
        this.selectedSchoolContacts,
        this.bookingService.booking.school.id!
      );
      this.bookingService.booking.highSchoolInfo = info;
      highSchoolInfo = info;
    }
    for(let form of this.contactFormArray.controls){
      let contact = new SchoolContact(
        form.value.contactType,
        form.value.contactName,
        form.value.contactEmail,
        form.value.contactPhoneNumber
      );
      highSchoolInfo.schoolContactList.push(contact);
    }
    this.httpService.putBookingHighSchoolInformation(highSchoolInfo, this.bookingService.booking.id!).subscribe(res => {
      if(!highSchoolInfo!.id){
        highSchoolInfo!.id = res.id;
      } 
      this.bookingService.booking.highSchoolInfo = highSchoolInfo;
      this.toastService.addSuccess("Success", "High school information updated");
      this.highSchoolForm.controls["contactForms"] = new FormArray([]);
      this.bookingService.sendingUpdateRequest = false;
    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addError("Error", apiError.message);
      this.bookingService.sendingUpdateRequest = false;
    });
  }

  contactOptionChange(){
    let selectedContact = this.highSchoolForm.value.selectedContact;
    if(!this.hasSameContact(selectedContact)){
      this.selectedSchoolContacts.push(selectedContact);
    }
    this.highSchoolForm.get("selectedContact")!.setValue(null);
  }

  hasSameContact(element: SchoolContact){
    for(let contact of this.selectedSchoolContacts){
      if(contact.id === element.id){
        return true;
      }
    }
    return false;
  }

  deleteContact(contact: SchoolContact){
    this.selectedSchoolContacts.splice(this.selectedSchoolContacts.indexOf(contact), 1);
  }

  addSchoolContactForm(){
    let contactFormArray = this.highSchoolForm.controls["contactForms"] as FormArray;
    contactFormArray.push(this.builder.group({
        contactType: [null, Validators.required],
        contactName: null,
        contactEmail: [null, EmailAddressValidator],
        contactPhoneNumber: [null, InternationalPhoneNumberValidator]
    }));
  }

  get contactFormArray(){
    return this.highSchoolForm.controls["contactForms"] as FormArray;
  }

  deleteContactForm(form: any){
    let formArray = this.contactFormArray;
    let index = formArray.controls.indexOf(form);
    if(index != -1){
      formArray.controls.splice(index, 1);
    }
  }
}
